'use strict';

const _ = require('underscore');
const ProjectStatusModel = require('common/domain/entity/project-status');

class ProjectStatusFactory {
    build(json) {
        return new Promise((resolve) => {
            const params = _.extend(json, {
                id: json.id || json.projectKey
            });
            resolve(new ProjectStatusModel(params));
        });
    }
}

module.exports = ProjectStatusFactory;



// WEBPACK FOOTER //
// ./common/domain/factory/project-status/index.js